<remote-update-domain-app-page-wrapper [data]="data()" [hasError]="hasError()"
    [emptyTitle]="emptyTitle" [emptyDescription]="emptyDescription" [isLoading]="isLoading()">
    <!-- Header -->
    <div header class="flex items-center justify-between pt-150-rem">
        <div>
            <p class="text-[1.5rem] text-[#292F32] w-full font-semibold">Firmware packages</p>
        </div>
        <div class="grid mt-050-em cursor-pointer">
            <button (click)="openDialog()" class="mx-auto" mat-flat-button color="primary">
                Create
            </button>
        </div>
    </div>

    <!-- Content -->
    <div content class="mt-150-rem">
        <remote-update-feature-remote-update-dashboard-firmware-table [packages]="data()">
        </remote-update-feature-remote-update-dashboard-firmware-table>
    </div>
</remote-update-domain-app-page-wrapper>